import React, { useContext, useEffect, useState } from 'react';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { NOTIFICATION_HUB_URL } from 'api/employeeManual';
import PropTypes from 'prop-types';

const NotificationContext = React.createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    return {
      latestNotification: null,
      connection: null,
      clearLatestNotification: () => {},
    };
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [latestNotification, setLatestNotification] = useState(null);
  const [connection, setConnection] = useState(null);

  const clearLatestNotification = () => setLatestNotification(null);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(NOTIFICATION_HUB_URL)
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    newConnection.on("JobFinished", (status, timestamp) => {
      setLatestNotification({ 
        status, 
        timestamp: new Date(timestamp),
        receivedAt: new Date()
      });
    });

    const startConnection = async () => {
      try {
        await newConnection.start();
        setConnection(newConnection);
      } catch (err) {
        console.error("SignalR Connection Error: ", err);
        setTimeout(startConnection, 5000);
      }
    };

    startConnection();

    return () => {
      newConnection.stop();
    };
  }, []);

  return (
    <NotificationContext.Provider value={{ latestNotification, connection, clearLatestNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
    children: PropTypes.node.isRequired,
};